module.exports = __webpack_public_path__ + "img/beer_id-100.a653e6a1.png";